import React, { useEffect, useRef, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
import { Urls } from "../../store/urls";

const CustomEditor5 = (props) => {
  const editorRef = useRef();
  useEffect(() => {
    if (props?.isPastedToStory && editorRef?.current) {
      if (props?.initData) {
        editorRef?.current?.data?.set(props?.initData);
      }
    }
  }, [props?.initData, props?.isPastedToStory, editorRef?.current]);

  const uploadImage = (body) => {
    return axios({
      method: "POST",
      url: Urls.POST_APPS_ARTICLE_IMAGE_API,
      data: body,
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });
  }

  function uploadAdapter(loader, editor) {
    return {
      upload: () => {
        return new Promise(async (resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append("image", file);
            uploadImage(body)
              .then((response) => {
                // handle the response
                resolve({ default: `${response.data?.data?.image_url}` });
              })
              .catch((error) => {
                // handle errors
                console.log(error);
              });
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return new uploadAdapter(loader, editor);
    };
  }

  return (
    <div className="ckeditor5_wrapper">
      <CKEditor
        editor={ClassicEditor}
        config={{
          extraPlugins: [uploadPlugin],
          toolbar: props?.config?.toolbar ?? [
            'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
            'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'undo', 'redo', 'imageUpload'
          ]
        }}
        data={props?.initData}
        onReady={(editor) => {
          editorRef.current = editor;
        }}
        onChange={(event, editor) => {
          const data = editor?.data?.get();
          if (props?.onChange) props.onChange(data);
        }}
        onBlur={props?.onBlur}
      />
    </div>
  );
};

export default CustomEditor5;